import { z } from 'zod';
import { CATEGORY_CODES } from '../categories';
import { MAX_AMOUNT_MINOR } from '../money';

export const moneySchema = z
  .object({
    amount: z.number().int(),
    currency: z.string().length(3).toUpperCase(),
  })
  .strict();

export const amountSchema = z.number().int().min(1).max(MAX_AMOUNT_MINOR);
export const noteSchema = z
  .string()
  .trim()
  .max(100)
  .transform((s) => (s.length ? s : null));
const categorySchema = z.enum(CATEGORY_CODES).nullable();

export const createTransactionSchema = z
  .object({
    client_request_id: z.string().uuid(),
    type: z.enum(['EXPENSE', 'SETTLEMENT']),
    payer_id: z.string().uuid(),
    amount: amountSchema,
    // Поддерживаемые валюты проверяет сервис → 400 UNSUPPORTED_CURRENCY
    currency: z.string().length(3).toUpperCase().default('UZS'),
    category: categorySchema.default(null),
    note: noteSchema.nullable().default(null),
    /** «Погасить полностью»: сервер сверяет с текущим балансом под блокировкой. */
    expected_balance: moneySchema.nullable().default(null),
  })
  .strict();
export type CreateTransactionInput = z.infer<typeof createTransactionSchema>;

export const updateTransactionSchema = z
  .object({
    version: z.number().int().min(1),
    amount: amountSchema.optional(),
    payer_id: z.string().uuid().optional(),
    category: categorySchema.optional(),
    note: noteSchema.nullable().optional(),
  })
  .strict();
export type UpdateTransactionInput = z.infer<typeof updateTransactionSchema>;

export const disputeSchema = z
  .object({
    reason: z
      .string()
      .trim()
      .max(200)
      .transform((s) => (s.length ? s : null))
      .nullable()
      .default(null),
  })
  .strict();
export type DisputeInput = z.infer<typeof disputeSchema>;

export const listTransactionsQuerySchema = z.object({
  cursor: z.string().max(200).optional(),
  limit: z.coerce.number().int().min(1).max(100).default(50),
});
